<template>
    <main class="landing-container">
        <section class="slogan">
            <div class="slogan-img"></div>
            <div class="main-title-wrapper">
                <div class="main-title">{{ $t('lp-investor31') }}</div>

                <div class="contactus-wrapper" v-if="!nextStep">
                    <div class="contactus-title">{{ $t('lp-investor32') }}</div>

                    <v-flex v-if="isBrowser">
                        <span class="login-label">{{ $t('myprofile1') }} *</span>
                        <v-text-field
                            id="regFName"
                            ref="regFName"
                            v-model="regFName"
                            class="email-input"
                            :rules="[rules.required]"
                            :error="$v.regFName.$dirty && $v.regFName.$error"
                        ></v-text-field>
                    </v-flex>
                    <v-flex v-if="isBrowser">
                        <span class="login-label">{{ $t('myprofile2') }} *</span>
                        <v-text-field
                            v-model="regLName"
                            class="email-input"
                            :rules="[rules.required]"
                            :error="$v.regLName.$dirty && $v.regLName.$error"
                        ></v-text-field>
                    </v-flex>
                    <v-flex>
                        <span class="login-label">Email *</span>
                        <v-text-field
                            ref="email"
                            v-model="regEmail"
                            class="email-input"
                            :rules="[rules.required, rules.emailValid]"
                        ></v-text-field>
                    </v-flex>
                    <v-flex>
                        <span class="login-label">Password *</span>
                        <v-text-field
                            ref="regPassword"
                            v-model="regPassword"
                            :append-icon="secureRegPassword ? 'mdi-eye' : 'mdi-eye-off'"
                            :rules="[rules.required, rules.min]"
                            :type="secureRegPassword ? 'password' : 'text'"
                            name="input-10-1"
                            hint="At least 8 characters"
                            @click:append="secureRegPassword = !secureRegPassword"
                            v-on:keyup.enter="registration"
                        >
                        </v-text-field>
                    </v-flex>
                    <v-checkbox
                        v-model="checked18"
                        :label="$t('register-confirm18')"
                    ></v-checkbox>
                    <v-checkbox
                        v-model="checkedTerms"
                        class="check-terms"
                    >
                        <div slot="label">
                            {{ $t('register-terms') }}
                        </div>
                    </v-checkbox>
                    <v-checkbox
                        v-model="checkedNews"
                        :label="$t('register-news')"
                        class="check-terms"
                    ></v-checkbox>
                    <v-flex>
                        <v-btn class="submit login-submit" v-on:click="() => { registration() }">{{ $t('register-create') }}</v-btn>
                    </v-flex>

                    <div class="social-or">{{ $t('or') }}</div>
                    <v-facebook-login v-if="isBrowser" class="fb-reg" app-id="4547708611999159" @login="loginFb" @sdk-init="handleSdkInit" :login-options=scopeOptions>
                        <button slot="login">{{ $t('reg-fb')}}</button>
                    </v-facebook-login>
                    <v-flex>
                        <div class="errors-container2" v-if="errorMsg !== ''">
                            <p>{{errorMsg}}</p>
                        </div>
                    </v-flex>
                </div>
                <div class="contactus-wrapper" v-else>
                    <div class="login-success">
                        <h2>Success!</h2>
                        <div class="additional-info">
                            Check your email for an account activation link!
                        </div>
                    </div>

                    <div class="login-success-btn-wrapper">
                        <v-btn class="btn-primary btn-bid-proceed" v-on:click="goToLogin">OK</v-btn>
                        <v-btn class="btn-bid-cancel" v-on:click="resendMail">Resend email</v-btn>
                    </div>
                </div>
                <div class="phone-wrapper">
                    <div class="phone1"></div>
                    <div class="phone2"></div>
                </div>
            </div>
        </section>

        <!--        <div class="main-subtitle">{{ $t('lp-investor30') }}</div>-->
        <!--        <div class="download-btn-wrapper">-->
        <!--            <div class="home-download-ios" v-on:click="showQR(true)"></div>-->
        <!--            <div class="home-download-android" v-on:click="showQR(false)"></div>-->
        <!--        </div>-->

        <section class="boxes">
            <div class="box box1">
                <div class="box-icon"></div>
                <div class="box-title">{{ $t('lp-investor2') }}</div>
                <div class="box-text-it" v-if="$i18n.locale === 'it'">
                    <ul>
                        <li>Accesso a centinaia di vini pregiati senza intermediari</li>
                        <li>Vini acquistati direttamente dai produttori a prezzi competitivi</li>
                        <li>Costi trasparenti e basse commissioni</li>
                    </ul>
                </div>
                <div class="box-text" v-else>
                    <ul>
                        <li>Direct and easy access to hundreds of investable wines.</li>
                        <li>Sourced directly from producers guaranteeing optimal prices.</li>
                        <li>Low commissions and transparent fees.</li>
                    </ul>
                </div>
            </div>
            <div class="box box2">
                <div class="box-icon"></div>
                <div class="box-title">{{ $t('lp-investor4') }}</div>
                <div class="box-text-it" v-if="$i18n.locale === 'it'">
                    <ul>
                        <li>Esperienza intuitiva per investire liberamente</li>
                        <li>Acquisto e vendita del vino in tempo reale tramite il nostro Live Market</li>
                        <li>Collezioni accuratamente selezionate acquistabili in pochi click</li>
                    </ul>
                </div>
                <div class="box-text" v-else>
                    <ul>
                        <li>Live market allowing you to buy & sell wine in real time.</li>
                        <li>Carefully selected Collections ready for purchase at set price.</li>
                        <li>A stress-free independent investment experience.</li>
                    </ul>
                </div>
            </div>
            <div class="box box3">
                <div class="box-icon"></div>
                <div class="box-title">{{ $t('lp-investor6') }}</div>
                <div class="box-text-it" v-if="$i18n.locale === 'it'">
                    <ul>
                        <li>Provenienza ed autenticità di tutti i vini garantita</li>
                        <li>Vini conservati in modo sicuro ed in sospensione d’IVA nei nostri depositi</li>
                        <li>Transazioni registrate su blockchain  garantendo  la tracciabilità</li>
                    </ul>
                </div>
                <div class="box-text" v-else>
                    <ul>
                        <li>Provenance and authenticity of all wines guaranteed.</li>
                        <li>Wines are stored safely in our bonded warehouse and fully insured.</li>
                        <li>All transactions recorded on blockchain.</li>
                    </ul>
                </div>
            </div>
        </section>

        <div class="lp-section2-btn" v-on:click="scrollToTop">{{ $t('lp-investor10') }}</div>

        <v-dialog v-model="showStore" persistent max-width="376px">
            <v-card class="qr-popup">
                <div class="qr-close" v-on:click="hideQR"></div>
                <div class="qr-title">Download the app</div>
                <div :class="{'qr-image': true, 'appStore': appStore, 'googlePlay': googlePlay}"></div>
            </v-card>
        </v-dialog>
    </main>
</template>

<script>
    import {email, minLength, required} from "vuelidate/lib/validators";
    import {mapActions} from "vuex";
    import {AAuth} from "~/store/actions";
    import {MAuth} from "~/store/mutations";

    export default {
        name: "LpInvestor3",
        head: {
            title: 'Campaign for investors | Fine Wine Trading App',
            meta: [
                {
                    hid: 'description',
                    name: 'description',
                    content: 'Buy and sell fine wines from your smartphone today! Vindome is the fast, secure and easy way to become a wine trader – right from your smartphone.'
                }
            ],
            bodyAttrs: {
                class: 'page-landing-investor'
            }
        },
        components: {
            VFacebookLogin: () => process.client ? import('vue-facebook-login-component') : null
        },
        validations: {
            regFName: {
                required
            },
            regLName: {
                required
            },
            regEmail: {
                required,
                email
            },
            regPassword: {
                required,
                minLength: minLength(8)
            }
        },
        data () {
            return {
                scopeOptions: {scope: ['email', 'public_profile']},
                showStore: false,
                appStore: false,
                googlePlay: false,
                regEmail: '',
                regPassword: '',
                isBrowser: false,
                regFName: '',
                regLName: '',
                countryId: 224,
                isLoading: false,
                checkedTerms: false,
                checked18: false,
                checkedNews: true,
                secureRegPassword: true,
                reg: /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,24}))$/,
                rules: {
                    required: value => !!value || 'Required.',
                    min: value => value.length >= 8 || 'Min 8 characters',
                    emailValid: value => this.isEmailValid(value) || 'Invalid email'
                },
                errorMsg: '',
                nextStep: false
            }
        },
        methods: {
            handleSdkInit({ FB, scope }) {
                this.FB = FB;
                this.fbScope = scope
            },
            loginFb(response) {
                if (typeof response !== 'undefined' && response.status === "connected") {
                    let _loginCtrl = this;

                    this.$store.dispatch(AAuth.LOGIN_EXTERNAL_USER, { accessToken: response.authResponse.accessToken }).then((res) => {
                        let token = res.access_token;
                        localStorage.setItem('access_token', token);
                        _loginCtrl.$store.commit(MAuth.SET_ACCESS_TOKEN, token);
                        _loginCtrl.$gtm.push({ event: "registration" });
                        window.fbq('track', 'CompleteRegistration');
                        window.uetq = window.uetq || [];
                        window.uetq.push("event", "signup", {});
                        _loginCtrl.$gtm.push({
                            'event': 'UETRegistration',
                            'ecomm_pagetype': 'conversion'
                        });

                        if (_loginCtrl.loginPath && _loginCtrl.loginPath !== '') {
                            localStorage.removeItem('login_path');
                            _loginCtrl.$router.push(this.localePath({ path: _loginCtrl.loginPath }));
                        } else {
                            _loginCtrl.$router.push(this.localePath({ path: '/home/collections' }));
                        }
                    });
                } else if (typeof response === 'undefined') {
                    let _loginCtrl = this;
                    let _token = this.FB.getAccessToken();

                    this.$store.dispatch(AAuth.LOGIN_EXTERNAL_USER, { accessToken: _token }).then((res) => {
                        let token = res.access_token;
                        localStorage.setItem('access_token', token);
                        _loginCtrl.$store.commit(MAuth.SET_ACCESS_TOKEN, token);
                        _loginCtrl.$gtm.push({ event: "registration" });
                        window.fbq('track', 'CompleteRegistration');
                        window.uetq = window.uetq || [];
                        window.uetq.push("event", "signup", {});
                        _loginCtrl.$gtm.push({
                            'event': 'UETRegistration',
                            'ecomm_pagetype': 'conversion'
                        });

                        if (_loginCtrl.loginPath && _loginCtrl.loginPath !== '') {
                            localStorage.removeItem('login_path');
                            _loginCtrl.$router.push(this.localePath({ path: _loginCtrl.loginPath }));
                        } else {
                            _loginCtrl.$router.push(this.localePath({ path: '/home/collections' }));
                        }
                    });
                }
            },
            scrollToTop() {
                window.scrollTo({
                    top: 0,
                    left: 0,
                    behavior: 'smooth'
                });
            },
            showQR(isAppStore) {
                this.showStore = true;
                this.appStore = isAppStore;
                this.googlePlay = !isAppStore;
            },
            hideQR() {
                this.showStore = false;
                this.appStore = false;
                this.googlePlay = false;
            },
            goToLogin() {
                this.$router.push(this.localePath({ path: '/' }));
            },
            isEmailValid(email) {
                return this.reg.test(email)
            },
            resendMail() {
                this.sendMail(this.regEmail)
            },
            registration() {
                this.$v.regFName.$touch();
                this.$v.regLName.$touch();
                if (this.regEmail && this.regPassword && !this.$v.regEmail.$invalid && !this.$v.regPassword.$invalid && !this.$v.regFName.$invalid && !this.$v.regLName.$invalid) {
                    if (this.checkedTerms && this.checked18) {
                        this.isLoading = true;
                        let payload = {
                            email: this.regEmail,
                            password: this.regPassword,
                            confirmPassword: this.regPassword,
                            firstname: this.regFName,
                            lastname: this.regLName,
                            countryId: this.countryId,
                            phoneNumber: '+ 1',
                            name: '',
                            enabledNotification: this.enabledNotification === true ? 1 : 0,
                            newsletter: this.checkedNews
                        };
                        this.signup(payload).then(res => {
                            if (res.statusCode === 400) {
                                this.isLoading = false;
                                this.errorMsg = 'Email is already in use.';
                            } else {
                                if (res.reasonPhrase === "Created") {
                                    this.nextStep = true;
                                }

                                this.$gtm.push({ event: "registration" });
                                window.fbq('track', 'CompleteRegistration');
                                window.uetq = window.uetq || [];
                                window.uetq.push("event", "signup", {});
                                this.$gtm.push({
                                    'event': 'UETRegistration',
                                    'ecomm_pagetype': 'conversion'
                                });
                            }
                        }).catch(err => {
                            this.isLoading = false;
                            if (err.status === 400) {
                                this.errorMsg = 'Email is already in use.';
                            } else {
                                this.errorMsg = 'Please try again.';
                            }
                        })
                    } else {
                        this.errorMsg = 'You must agree with the terms of service and confirm that you are at least 18 years old.';
                    }
                } else {
                    this.errorMsg = 'Please fill the above information.';
                }
            },
            ...mapActions({
                signup: AAuth.REG_USER,
                signin: AAuth.GET_TOKEN,
                sendMail: AAuth.SEND_MAIL
            })
        },
        mounted () {
            this.isBrowser = process.browser
        }
    }
</script>

<style scoped>
    .social-or {
        margin-top: 10px;
        margin-bottom: 6px;
        width: 100%;
        text-align: center;
        font-family: Montserrat, sans-serif;
        font-style: normal;
        font-weight: normal;
        font-size: 14px;
        line-height: 17px;
        color: rgba(0, 0, 0, 0.64);
    }
    .fb-reg {
        text-align: center;
        padding: 13px;
        width: 100%;
        height: 44px;
        background: #FFFFFF url('../assets/landing/fb.png') no-repeat 10px 11px !important;
        border: 1px solid #000000 !important;
        color: #000000 !important;
        box-sizing: border-box;
        border-radius: 4px;
        margin-top: 16px;
        margin-bottom: 0;
    }
    .fb-reg:hover {
        cursor: pointer;
        color: #1f4e79;
        background-color: #ffffff;
    }
    .lp-section2-btn {
        display: block;
        width: 148px;
        height: 40px;
        background: #CEA94B;
        border-radius: 4px;
        font-family: Montserrat, sans-serif;
        font-style: normal;
        font-weight: bold;
        font-size: 14px;
        line-height: 40px;
        text-align: center;
        text-transform: uppercase;
        color: #FFFFFF;
        margin: 0 auto 48px;
        text-decoration: none;
    }
    .lp-section2-btn:hover {
        cursor: pointer;
        background: #ecd9a7;
    }
    .boxes {
        position: relative;
        width: 1174px;
        margin: 50px auto;
    }
    .box {
        display: inline-block;
        padding: 32px;
        width: calc((100% - 88px) / 3);
        height: 320px;
        background: #FFFFFF;
        box-shadow: 0 2px 12px rgba(0, 0, 0, 0.16);
        border-radius: 8px;
        vertical-align: top;
    }
    .box2 {
        margin: 0 40px;
    }
    .box-icon {
        width: 80px;
        height: 80px;
        margin: 0 auto;
    }
    .box1 .box-icon {
        background: url('../assets/landing/investor/lp1.png') no-repeat center top;
        background-size: cover;
    }
    .box2 .box-icon {
        background: url('../assets/landing/investor/lp2.png') no-repeat center top;
        background-size: cover;
    }
    .box3 .box-icon {
        background: url('../assets/landing/investor/lp3.png') no-repeat center top;
        background-size: cover;
    }
    .box-title {
        position: static;
        height: 22px;
        font-family: Montserrat, sans-serif;
        font-style: normal;
        font-weight: 600;
        font-size: 18px;
        line-height: 22px;
        text-align: center;
        color: rgba(0, 0, 0, 0.88);
        margin-top: 24px;
    }
    .box-text {
        font-family: Montserrat, sans-serif;
        font-style: normal;
        font-weight: normal;
        font-size: 14px;
        line-height: 17px;
        text-align: left;
        color: rgba(0, 0, 0, 0.64);
        flex: none;
        order: 1;
        align-self: stretch;
        flex-grow: 0;
        margin: 8px 0;
    }
    .box-text-it {
        font-family: Montserrat, sans-serif;
        font-style: normal;
        font-weight: normal;
        font-size: 14px;
        line-height: 17px;
        text-align: left;
        color: rgba(0, 0, 0, 0.64);
        flex: none;
        order: 1;
        align-self: stretch;
        flex-grow: 0;
        margin: 8px 0;
    }
    .box-text-it ul,
    .box-text ul {
        padding-left: 0;
        list-style-position: outside;
    }
    .qr-popup.v-card {
        border-radius: 24px;
        height: 390px;
    }
    .qr-image {
        width: 320px;
        height: 300px;
        margin: 0 auto;
    }
    .qr-image.appStore {
        background: #ffffff url('../assets/appstore-qr.svg') no-repeat center;
        background-size: 280px;
    }
    .qr-image.googlePlay {
        background: #ffffff url('../assets/gplay-qr.svg') no-repeat center;
        background-size: 280px;
    }
    .qr-title {
        text-align: center;
        font-size: 22.5px;
        line-height: 31.5px;
        color: #090D0E;
        padding-top: 20px;
    }
    .qr-close {
        position: absolute;
        z-index: 1;
        top: 16px;
        right: 16px;
        width: 40px;
        height: 40px;
        border-radius: 55%;
        background: #E6C67C url('../assets/icon-close.svg') no-repeat center;
    }
    .qr-close:hover {
        background-color: #F1E2C4;
        cursor: pointer;
    }
    .qr-popup .stores {
        margin: 0;
    }
    .qr-popup .appstore, .qr-popup .gplay {
        width: 118px;
        height: 38px;
        margin: 0 auto;
        display: block;
    }
    .home-download-android,
    .home-download-ios {
        display: inline-block;
        width: 163px;
        height: 48px;
    }
    .home-download-ios {
        background: url('../assets/app/appstore.png') no-repeat center;
        width: 144px;
        margin-right: 16px;
    }
    .home-download-android {
        background: url('../assets/app/gplay.png') no-repeat center;
    }
    .home-download-android:hover,
    .home-download-ios:hover {
        cursor: pointer;
    }
    .download-btn-wrapper {
        margin: 50px auto 0;
        text-align: center;
    }
    .main-subtitle {
        width: 100%;
        text-align: center;
        margin-top: 48px;
        margin-bottom: 32px;
        font-family: Montserrat, sans-serif;
        font-style: normal;
        font-weight: 600;
        font-size: 24px;
        line-height: 29px;
    }
    .download-btn-wrapper {
        margin: 0 auto 50px;
        text-align: center;
    }
    .home-download-android,
    .home-download-ios {
        display: inline-block;
        width: 163px;
        height: 48px;
    }
    .home-download-ios {
        background: url('../assets/app/appstore.png') no-repeat center;
        width: 144px;
        margin-right: 16px;
    }
    .home-download-android {
        background: url('../assets/app/gplay.png') no-repeat center;
    }
    .home-download-android:hover,
    .home-download-ios:hover {
        cursor: pointer;
    }
    .slogan {
        height: 878px;
        position: relative;
        overflow: hidden;
    }
    .slogan-img {
        background: url('../assets/landing/lp-lover.png') no-repeat center top;
        background-size: cover;
        width: 100%;
        height: 100%;
    }
    .main-title-wrapper {
        position: absolute;
        top: 96px;
        width: 1366px;
        height: calc(100% - 96px);
        max-width: 100%;
        left: 0;
        right: 0;
        margin: 0 auto;
        padding: 0 15px;
    }
    .main-title {
        width: 100%;
        height: 51px;
        font-family: Montserrat, sans-serif;
        font-style: normal;
        font-weight: bold;
        font-size: 42px;
        line-height: 51px;
        display: block;
        align-items: center;
        text-align: center;
        color: #FFFFFF;
        margin-bottom: 40px;
    }
    .contactus-wrapper {
        width: 380px;
        height: 651px;
        left: 0;
        top: 0;
        background: #F5F5F5;
        border-radius: 8px;
        padding: 24px;
    }
    .phone2 {
        position: absolute;
        z-index: 9;
        bottom: 0;
        right: 0;
        width: 339px;
        height: 602px;
        background: url('../assets/landing/lp-lover1.png') no-repeat center top;
    }
    .phone1 {
        position: absolute;
        z-index: 8;
        bottom: 0;
        right: 290px;
        width: 310px;
        height: 546px;
        background: url('../assets/landing/lp-lover2.png') no-repeat center top;
    }
    .contactus-title {
        font-family: Montserrat, sans-serif;
        font-style: normal;
        font-weight: 600;
        font-size: 18px;
        line-height: 22px;
        text-align: center;
        color: rgba(0, 0, 0, 0.88);
        margin-bottom: 6px;
    }
    .errors-container2 {
        height: auto;
        width: 100%;
        text-align: center;
        background: rgba(215,83,83, 0.08);
    }
    .errors-container2 p {
        color: #D75353;
        line-height: 18px;
        font-size: 13px;
        padding-left: 15px;
    }
    .login-success-btn-wrapper {
        margin-top: 40px;
    }
    .login-success-btn-wrapper .btn-bid-proceed.theme--light.v-btn:not(.v-btn--flat):not(.v-btn--text):not(.v-btn--outlined) {
        font-size: var(--fs-base);
        text-transform: initial;
        font-weight: 300;
        padding: 0 20px !important;
        background-color: var(--brand);
        color: #ffffff;
        min-width: 150px;
        margin-right: 15px;
    }
    .login-success-btn-wrapper .btn-bid-cancel.theme--light.v-btn:not(.v-btn--flat):not(.v-btn--text):not(.v-btn--outlined) {
        font-size: var(--fs-base);
        text-transform: initial;
        font-weight: 300;
        padding: 0 20px !important;
    }
    .login-success {
        text-align: center;
        background: url('../assets/success_icon.png') no-repeat center 30px;
        padding: 140px 32px 0;
    }
    .page-landing-investor {
        text-align: center;
        padding: 0 calc(3*var(--gutter)) calc(4*var(--gutter));
    }
    .logo-img {
        background: url('../assets/v_dark.svg') no-repeat center 50px;
        background-size: contain;
        width: 300px;
        height: 180px;
        margin: 0 auto;
    }
    h2 {
        color: #707070;
        margin-bottom: calc(2*var(--gutter));
    }
    .login-inner-container {
        max-width: 700px;
        background: #F5F6F5;
        border-radius: 10px;
        padding: 30px 50px 50px;
        margin: 0 auto;
        position: relative;
    }
    .login-label {
        position: absolute;
        font-size: 12px;
        color: #303030;
        font-weight: 300;
    }
    .page-landing-investor .submit {
        margin-top: 0;
        background: #E1C376 !important;
        color: #FFF !important;
        width: 100%;
        height: 40px !important;
        border-radius: 5px;
        letter-spacing: 0;
        box-shadow: none;
        margin-left: 0;
        margin-right: 0;
        font-family: Montserrat, sans-serif;
        font-style: normal;
        font-weight: bold;
        font-size: 14px;
        line-height: 17px;
        text-align: center;
        text-transform: uppercase;
    }
    .footer-links {
        max-width: 700px;
        margin: 20px auto 0;
        display: flex;
    }
    .footer-link {
        display: inline-block;
        width: 33.33%;
    }
    .footer-links .terms {
        width: max-content;
        margin: 0 auto;
    }
    .footer-links .forgot-pass,
    .footer-links .create-account{
        width: max-content;
    }
    .footer-links .create-account {
        float: right;
    }
    .link-border {
        height: 1px;
        width: 100%;
        background: #707070;
    }
    .footer-links > div:hover .link-border {
        background: var(--brand);
    }
    .check-terms {
        margin-top: 0;
    }

    @media(max-width: 768px) {
        .phone-wrapper {
            display: none;
        }
        .main-title {
            font-size: 30px;
        }
        .contactus-wrapper {
            margin: 0 auto;
        }
        .main-subtitle {
            padding: 0 15px;
        }
    }

    @media(max-width: 767px) {
        .boxes {
            top: 40px;
            width: 100%;
        }
        .box {
            width: calc(100% - 30px);
            margin: 0 15px;
        }
        .box2 {
            margin: 40px 15px;
        }
        .main-title-wrapper {
            top: 80px;
        }
        .contactus-wrapper {
            width: 100%;
        }
        .main-title {
            font-size: 24px;
            line-height: 29px;
            height: auto;
            margin-bottom: 32px;
        }
        h2 {
            font-weight: 300;
            font-size: 28px;
            line-height: 30px;
        }
        .page-landing-investor .submit {
            width: 100%;
        }
        .page-landing-investor {
            padding: 0 15px 30px;
        }
        .logo-img {
            background: url('../assets/v_dark.svg') no-repeat center;
            background-size: contain;
            width: 170px;
            height: 80px;
        }
        .login-inner-container {
            padding: 30px 15px;
        }
        .footer-links {
            display: block;
        }
        .footer-link {
            display: block;
            width: 100%;
            text-align: center !important;
        }
        .footer-links .forgot-pass,
        .footer-links .create-account {
            width: 100%;
        }
        .link-border {
            height: 0;
        }
        .footer-links .create-account {
            float: none;
            margin-top: 5px;
        }
        .footer-links .terms {
            margin-top: 5px;
        }
    }
</style>
<style>
    .page-landing-investor .v-main {
        padding-top: 0 !important;
    }
    .page-landing-investor .logo {
        display: block;
        margin: 0 auto;
        width: 206px;
    }
    .page-landing-investor .fb-reg .logo {
        display: none;
    }
    .page-landing-investor .fb-reg button {
        font-family: Montserrat, sans-serif;
        font-style: normal;
        font-weight: bold;
        font-size: 14px;
        line-height: 17px;
        text-transform: uppercase;
        color: rgba(0, 0, 0, 0.88);
    }
    .page-landing-investor .fb-reg button:hover {
        cursor: pointer;
        color: #1f4e79;
        background-color: #ffffff;
    }
    .page-landing-investor .logo img {
        margin-top: 18px;
        width: 172px;
    }
    .page-landing-investor .theme--dark.v-sheet.header-toolbar.v-app-bar--is-scrolled .logo img {
        margin-top: 10px;
    }
    .page-landing-investor .nav-second-row,
    .page-landing-investor .nav-first-row-right {
        display: none;
    }
    .page-landing-investor .flex {
        margin-top: 10px;
        text-align: left;
        position: relative;
    }
    .page-landing-investor .v-text-field__details {
        bottom: -7px;
        position: absolute;
    }
    .page-landing-investor .v-input input {
        height: 40px;
        max-height: unset;
        margin-top: 4px;
        padding-left: 15px;
    }
    .page-landing-investor .v-text-field .v-input__append-inner {
        margin-top: 4px;
        background: #fff;
        height: 40px;
    }
    .page-landing-investor .v-text-field .v-input__append-inner .v-input__icon {
        margin-top: 8px;
        margin-right: 3px;
    }
    .page-landing-investor .v-text-field .v-input__append-inner .primary--text {
        color: #000 !important;
        caret-color: #000 !important;
    }
    .page-landing-investor .theme--light.v-input:not(.v-input--is-disabled) input {
        border: 0;
    }
    .page-landing-investor .theme--light.v-text-field:not(.v-input--has-state)>.v-input__control>.v-input__slot:hover:before {
        border-color: var(--brand);
    }
    .page-landing-investor .theme--light.v-text-field>.v-input__control>.v-input__slot:after {
        border-color: rgba(0,0,0,.87);
        border-width: 1px;
    }
    .page-landing-investor .theme--light.v-text-field.error--text>.v-input__control>.v-input__slot:after {
        border-color: #ff5252;
    }
    .page-landing-investor .footer-links a,
    .page-landing-investor .check-terms a {
        text-decoration: none;
        color: #707070;
        font-size: 19px;
        font-weight: 300;
    }
    .page-landing-investor .footer-links a:hover,
    .page-landing-investor .check-terms a:hover {
        color: var(--brand);
    }
    .theme--light.v-application.loginpage {
        background: #ffffff;
    }
    .page-landing-investor .v-input--checkbox .v-messages {
        display: none;
    }

    .page-landing-investor .v-input--selection-controls:not(.v-input--hide-details) .v-input__slot {
        margin-bottom: 6px;
    }
    .page-landing-investor .v-input input[type=checkbox] {
        width: 18px;
        height: 18px;
    }

    .page-landing-investor .v-input--selection-controls:not(.v-input--hide-details) .v-input__slot .v-icon.v-icon {
        font-size: 18px;
    }

    .page-landing-investor .v-input--selection-controls__input {
        margin-right: 0;
    }

    .page-landing-investor .v-input--selection-controls.v-input .v-label {
        font-size: 12px;
    }

    .page-landing-investor .v-application .accent--text {
        color: #E2C477 !important;
        caret-color: #E2C477 !important;
    }

    @media (max-width: 767px) {
        .page-landing-investor .v-application .hidden-md-and-up {
            display: none !important;
        }
        .page-landing-investor .logo,
        .page-landing-investor .logo img {
            width: 106px;
            margin: 0;
        }
        .page-landing-investor .logo {
            margin: 15px auto 0;
        }
        .page-landing-investor .swiper-container {
            height: 390px;
        }
    }
</style>
